<template>
    <div>
        <Breadcrumbs main="Preference" title="Preference Insights">
            <!-- <div class="form-group">
                <b-form-select @change="getReport" style="width:150px" v-model="report" :options="reportOptions"></b-form-select>
            </div> -->
        </Breadcrumbs>

        
        <!-- <div class="form-group">
            <b-form-select @change="getReport" style="width:150px" v-model="report" :options="reportOptions"></b-form-select>
        </div> -->
        <div class="container-fluid">
            <div class="row ">
                <div v-for="cat in items" :key="cat.cat" class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="box" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0"> {{ cat.cat }} </span>
                          <h4 class="mb-0 counter">{{ (cat.value/users)*100+'%' }}</h4><feather type="box" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: 'VisitReport',
        data() {
            return {
                reportOptions: [
                                    { value: null, text: 'Select Report' },
                                    // { value: 'T', text: 'Today' },
                                    // { value: 'YS', text: 'Yesterday' },
                                    // { value: 'W', text: 'This Week' },
                                    // { value: 'M', text: 'This Month' },
                                    { value: 'Y', text: 'This Year' },
                                    // { value: 'PW', text: 'Previous Week' },
                                    // { value: 'PM', text: 'Previous Month' },
                                    { value: 'PY', text: 'Previous Year' },
                            ],
                report: 'Y',
                users: 0,
                items: [],
                week: null
            }
        },
        computed: {
            userAdmin() {
            return localStorage.getItem('type') == "admin" ? true : false
            },
            getUser() {
            return this.$store.getters['authentication/getUser']
            }
        },
        mounted() {
          
          // const today = moment(new Date(2023,7,8));
          // // const from_date = today.startOf('week');weekday()
          // const from_date = today.weekday();
          // const to_date = today.endOf('week');
          // console.log({
          //   from_date: from_date.toString(),
          //   today: moment().toString(),
          //   to_date: to_date.toString(),
          // });

          // // const  start = today.subtract(7, 'days')
          // // console.log(start)
          // let days = [] 
          // for (let index = 0; index < 7; index++) {

          //   const d = moment().subtract(7, 'days').add(1+index, 'days').toDate().toDateString().substring(4)
            
          //   days.push(d)
          // }
          // // console.log(days)
          // this.week = days
          this.getWeek()
        },
        created() {
            // watch and fetch
            this.$watch(
            () => this.$route.$params,
            () => {
                this.fetchData()
            },
            { immediate: true }

            )

        },
        methods: {
            fetchData() {
                
                const url = this.userAdmin ? '/pref/' : '/pref/'+this.$store.getters['authentication/getUser'].name

                axios.get(url)
                  .then(response=>{
                    //
                    this.items = response.data
                    this.users = this.items.length

                    //
                    // this.male = this.items.filter(u=> u.gender == 'male').length
                    // this.female = this.items.filter(u=> u.gender == 'female').length

                    let pref = []

                    for (let index = 0; index < this.items.length; index++) {

                          const shop = this.items[index].shops.find(shop => shop.shop == this.$store.getters['authentication/getUser'].name)

                          if (shop) {
                            this.items[index].preferences = shop.preferences
                          }

                          pref.push(shop.preferences)

                        //   this.items[index].point = this.items[index].points.length > 0 ? this.userAdmin ? parseFloat(this.items[index].points.reduce((a, b) => a + b.point, 0) ) : parseFloat(this.items[index].points.filter(s=>s.shop == this.getUser.name).reduce((a, b) => a + b.point, 0) ) : 0
                          
                      }

                      let allpref = pref.flat()

                      let array = []

                      for (let index = 0; index < this.getUser.categories.length; index++) {
                        //
                        let c = 0;

                        allpref.forEach(v=>v === this.getUser.categories[index] && c++)
                        
                        array.push ({ cat: this.getUser.categories[index], value: c});

                      }
                      
                      array.sort(function(a, b) {
                        return parseFloat(b.value) - parseFloat(a.value);
                      });

                      this.items = array


                  })
                  .catch( e => {
                    this.$swal({
                      title:"Failed!",
                      text:e.response.data,
                      type:'error'
                    });
                  })

            },
            getReport() {
                console.log(this.report)
            },
        }
    }
</script>

<style lang="scss" scoped>

</style>